import DocumentValidator from "../../../../services/DocumentValidator";
import EmailValidator from "../../../../services/EmailValidator";
import PhoneValidator from "../../../../services/PhoneValidator";
import BankDataValidator from "../../../../services/BankDataValidator";
export default {
  methods: {
    addError(section, field) {
      if (!this.errors[section].includes(field)) {
        this.errors[section].push(field);
      }
    },
    removeError(section, field) {
      if (this.errors[section].includes(field)) {
        this.errors[section].splice(this.errors[section].indexOf(field), 1);
      }
    },
    validateTextField(section, field) {
      if (this.form[field].length === 0) {
        this.addError(section, field);
      } else {
        this.removeError(section, field);
      }
    },
    validateBooleanField(section, field) {
      if (this.form[field] !== true) {
        this.addError(section, field);
      } else {
        this.removeError(section, field);
      }
    },
    validateSelectField(section, field) {
      if (!this.form[field]) {
        this.addError(section, field);
      } else {
        this.removeError(section, field);
      }
    },
    validateEmailField(section, field) {
      this.validateTextField(section, field);
      EmailValidator.validateFormat(this.form[field])
        ? this.removeError(section, field)
        : this.addError(section, field);
    },

    validateNifField(section, field) {
      this.validateTextField(section, field);
      DocumentValidator.validateDocument(this.form[field])
        ? this.removeError(section, field)
        : this.addError(section, field);
    },
    validateIbanField(section, field) {
      this.validateTextField(section, field);
      BankDataValidator.isValidIBANNumber(this.form[field])
        ? this.removeError(section, field)
        : this.addError(section, field);
    },
    validateSwiftField(section, field) {
      this.validateTextField(section, field);
      BankDataValidator.isValidSwift(this.form[field])
        ? this.removeError(section, field)
        : this.addError(section, field);
    },
    validatePhoneField(section, field, required = true) {
      if (required && this.form[field].length === 0) {
        this.validateTextField(section, field);
        return;
      }
      if (required) this.validateTextField(section, field);
      if (this.form[field].length != 0) {
        PhoneValidator.validateFormat(this.form[field])
          ? this.removeError(section, field)
          : this.addError(section, field);
      } else {
        this.removeError(section, field);
      }
    },

    validateCheckboxField(section, field) {
      this.validateBooleanField(section, field);
    },

    validateRadioButtonField(section, field) {
      if (!this.form[field]) {
        this.addError(section, field);
      } else {
        this.removeError(section, field);
      }
    },
  },
};
